import styled from 'styled-components';

const FilterWrapper = styled.div`
  width: 67px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color:#000;
  `;

export default FilterWrapper;
